// source: messages/cases.message.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var messages_core_message_pb = require('../messages/core.message_pb.js');
goog.object.extend(proto, messages_core_message_pb);
goog.exportSymbol('proto.cases_messages.Case', null, global);
goog.exportSymbol('proto.cases_messages.CaseListing', null, global);
goog.exportSymbol('proto.cases_messages.CaseSearchRequest', null, global);
goog.exportSymbol('proto.cases_messages.CaseSearchResponse', null, global);
goog.exportSymbol('proto.cases_messages.CasesListRequest', null, global);
goog.exportSymbol('proto.cases_messages.CasesListResponse', null, global);
goog.exportSymbol('proto.cases_messages.ClaimsLampCase', null, global);
goog.exportSymbol('proto.cases_messages.GetCaseRequest', null, global);
goog.exportSymbol('proto.cases_messages.GetCaseResponse', null, global);
goog.exportSymbol('proto.cases_messages.GetClaimsLampCaseRequest', null, global);
goog.exportSymbol('proto.cases_messages.GetClaimsLampCaseResponse', null, global);
goog.exportSymbol('proto.cases_messages.GetLampCaseRequest', null, global);
goog.exportSymbol('proto.cases_messages.GetLampCaseResponse', null, global);
goog.exportSymbol('proto.cases_messages.LampCase', null, global);
goog.exportSymbol('proto.cases_messages.SyncPassWithLampCaseIdRequest', null, global);
goog.exportSymbol('proto.cases_messages.SyncPassWithLampCaseIdResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.Case = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.Case, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.Case.displayName = 'proto.cases_messages.Case';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.LampCase = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.LampCase, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.LampCase.displayName = 'proto.cases_messages.LampCase';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.ClaimsLampCase = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.ClaimsLampCase, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.ClaimsLampCase.displayName = 'proto.cases_messages.ClaimsLampCase';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.CaseListing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.CaseListing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.CaseListing.displayName = 'proto.cases_messages.CaseListing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.CaseSearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.CaseSearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.CaseSearchRequest.displayName = 'proto.cases_messages.CaseSearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.CaseSearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cases_messages.CaseSearchResponse.repeatedFields_, null);
};
goog.inherits(proto.cases_messages.CaseSearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.CaseSearchResponse.displayName = 'proto.cases_messages.CaseSearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.GetCaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.GetCaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.GetCaseRequest.displayName = 'proto.cases_messages.GetCaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.GetCaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.GetCaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.GetCaseResponse.displayName = 'proto.cases_messages.GetCaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.GetLampCaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.GetLampCaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.GetLampCaseRequest.displayName = 'proto.cases_messages.GetLampCaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.GetLampCaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.GetLampCaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.GetLampCaseResponse.displayName = 'proto.cases_messages.GetLampCaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.GetClaimsLampCaseRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.GetClaimsLampCaseRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.GetClaimsLampCaseRequest.displayName = 'proto.cases_messages.GetClaimsLampCaseRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.GetClaimsLampCaseResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.GetClaimsLampCaseResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.GetClaimsLampCaseResponse.displayName = 'proto.cases_messages.GetClaimsLampCaseResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.CasesListRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.CasesListRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.CasesListRequest.displayName = 'proto.cases_messages.CasesListRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.CasesListResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cases_messages.CasesListResponse.repeatedFields_, null);
};
goog.inherits(proto.cases_messages.CasesListResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.CasesListResponse.displayName = 'proto.cases_messages.CasesListResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.SyncPassWithLampCaseIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.SyncPassWithLampCaseIdRequest.displayName = 'proto.cases_messages.SyncPassWithLampCaseIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cases_messages.SyncPassWithLampCaseIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cases_messages.SyncPassWithLampCaseIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cases_messages.SyncPassWithLampCaseIdResponse.displayName = 'proto.cases_messages.SyncPassWithLampCaseIdResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.Case.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.Case.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.Case} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.Case.toObject = function(includeInstance, msg) {
  var f, obj = {
caseid: jspb.Message.getFieldWithDefault(msg, 1, 0),
lampcaseid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
memberid: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
attyid: jspb.Message.getFieldWithDefault(msg, 4, 0),
providername: jspb.Message.getFieldWithDefault(msg, 5, ""),
provideremail: jspb.Message.getFieldWithDefault(msg, 6, ""),
providercity: jspb.Message.getFieldWithDefault(msg, 7, ""),
providerstate: jspb.Message.getFieldWithDefault(msg, 8, ""),
providerzip: jspb.Message.getFieldWithDefault(msg, 9, ""),
clientnamefirst: jspb.Message.getFieldWithDefault(msg, 10, ""),
clientnamelast: jspb.Message.getFieldWithDefault(msg, 11, ""),
clientgroupid: jspb.Message.getFieldWithDefault(msg, 12, ""),
clientemailaddress: jspb.Message.getFieldWithDefault(msg, 13, ""),
intakedate: jspb.Message.getFieldWithDefault(msg, 14, 0),
referralaccepteddate: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.Case}
 */
proto.cases_messages.Case.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.Case;
  return proto.cases_messages.Case.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.Case} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.Case}
 */
proto.cases_messages.Case.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLampcaseid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvidername(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvideremail(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvidercity(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderstate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderzip(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientnamefirst(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientnamelast(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientgroupid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientemailaddress(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIntakedate(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReferralaccepteddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.Case.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.Case.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.Case} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.Case.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAttyid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getProvidername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProvideremail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProvidercity();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getProviderstate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getProviderzip();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getClientnamefirst();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getClientnamelast();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getClientgroupid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getClientemailaddress();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getIntakedate();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeInt64(
      15,
      f
    );
  }
};


/**
 * optional int32 caseID = 1;
 * @return {number}
 */
proto.cases_messages.Case.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lampCaseId = 2;
 * @return {number}
 */
proto.cases_messages.Case.prototype.getLampcaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setLampcaseid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.clearLampcaseid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.Case.prototype.hasLampcaseid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 memberId = 3;
 * @return {number}
 */
proto.cases_messages.Case.prototype.getMemberid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setMemberid = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.clearMemberid = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.Case.prototype.hasMemberid = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 attyId = 4;
 * @return {number}
 */
proto.cases_messages.Case.prototype.getAttyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setAttyid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string providerName = 5;
 * @return {string}
 */
proto.cases_messages.Case.prototype.getProvidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setProvidername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string providerEmail = 6;
 * @return {string}
 */
proto.cases_messages.Case.prototype.getProvideremail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setProvideremail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string providerCity = 7;
 * @return {string}
 */
proto.cases_messages.Case.prototype.getProvidercity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setProvidercity = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string providerState = 8;
 * @return {string}
 */
proto.cases_messages.Case.prototype.getProviderstate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setProviderstate = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string providerZip = 9;
 * @return {string}
 */
proto.cases_messages.Case.prototype.getProviderzip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setProviderzip = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string clientNameFirst = 10;
 * @return {string}
 */
proto.cases_messages.Case.prototype.getClientnamefirst = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setClientnamefirst = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string clientNameLast = 11;
 * @return {string}
 */
proto.cases_messages.Case.prototype.getClientnamelast = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setClientnamelast = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string clientGroupID = 12;
 * @return {string}
 */
proto.cases_messages.Case.prototype.getClientgroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setClientgroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string clientEmailAddress = 13;
 * @return {string}
 */
proto.cases_messages.Case.prototype.getClientemailaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setClientemailaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 intakeDate = 14;
 * @return {number}
 */
proto.cases_messages.Case.prototype.getIntakedate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setIntakedate = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 referralAcceptedDate = 15;
 * @return {number}
 */
proto.cases_messages.Case.prototype.getReferralaccepteddate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.setReferralaccepteddate = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.Case} returns this
 */
proto.cases_messages.Case.prototype.clearReferralaccepteddate = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.Case.prototype.hasReferralaccepteddate = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.LampCase.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.LampCase.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.LampCase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.LampCase.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
legalmattercounty: jspb.Message.getFieldWithDefault(msg, 2, ""),
areaoflaw: jspb.Message.getFieldWithDefault(msg, 3, ""),
memberid: jspb.Message.getFieldWithDefault(msg, 4, 0),
legalmatterstate: (f = msg.getLegalmatterstate()) && messages_core_message_pb.State.toObject(includeInstance, f),
createdat: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.LampCase}
 */
proto.cases_messages.LampCase.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.LampCase;
  return proto.cases_messages.LampCase.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.LampCase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.LampCase}
 */
proto.cases_messages.LampCase.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalmattercounty(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAreaoflaw(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMemberid(value);
      break;
    case 5:
      var value = new messages_core_message_pb.State;
      reader.readMessage(value,messages_core_message_pb.State.deserializeBinaryFromReader);
      msg.setLegalmatterstate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.LampCase.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.LampCase.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.LampCase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.LampCase.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getLegalmattercounty();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAreaoflaw();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMemberid();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLegalmatterstate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      messages_core_message_pb.State.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.cases_messages.LampCase.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.LampCase} returns this
 */
proto.cases_messages.LampCase.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string legalMatterCounty = 2;
 * @return {string}
 */
proto.cases_messages.LampCase.prototype.getLegalmattercounty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.LampCase} returns this
 */
proto.cases_messages.LampCase.prototype.setLegalmattercounty = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string areaOfLaw = 3;
 * @return {string}
 */
proto.cases_messages.LampCase.prototype.getAreaoflaw = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.LampCase} returns this
 */
proto.cases_messages.LampCase.prototype.setAreaoflaw = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 memberId = 4;
 * @return {number}
 */
proto.cases_messages.LampCase.prototype.getMemberid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.LampCase} returns this
 */
proto.cases_messages.LampCase.prototype.setMemberid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional core_messages.State legalMatterState = 5;
 * @return {?proto.core_messages.State}
 */
proto.cases_messages.LampCase.prototype.getLegalmatterstate = function() {
  return /** @type{?proto.core_messages.State} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.State, 5));
};


/**
 * @param {?proto.core_messages.State|undefined} value
 * @return {!proto.cases_messages.LampCase} returns this
*/
proto.cases_messages.LampCase.prototype.setLegalmatterstate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cases_messages.LampCase} returns this
 */
proto.cases_messages.LampCase.prototype.clearLegalmatterstate = function() {
  return this.setLegalmatterstate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.LampCase.prototype.hasLegalmatterstate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 createdAt = 6;
 * @return {number}
 */
proto.cases_messages.LampCase.prototype.getCreatedat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.LampCase} returns this
 */
proto.cases_messages.LampCase.prototype.setCreatedat = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.LampCase} returns this
 */
proto.cases_messages.LampCase.prototype.clearCreatedat = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.LampCase.prototype.hasCreatedat = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.ClaimsLampCase.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.ClaimsLampCase.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.ClaimsLampCase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.ClaimsLampCase.toObject = function(includeInstance, msg) {
  var f, obj = {
caseid: jspb.Message.getFieldWithDefault(msg, 1, 0),
lampcaseid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
memberid: jspb.Message.getFieldWithDefault(msg, 3, 0),
attyid: jspb.Message.getFieldWithDefault(msg, 4, 0),
providername: jspb.Message.getFieldWithDefault(msg, 5, ""),
provideremail: jspb.Message.getFieldWithDefault(msg, 6, ""),
providercity: jspb.Message.getFieldWithDefault(msg, 7, ""),
providerstate: jspb.Message.getFieldWithDefault(msg, 8, ""),
providerzip: jspb.Message.getFieldWithDefault(msg, 9, ""),
clientnamefirst: jspb.Message.getFieldWithDefault(msg, 10, ""),
clientnamelast: jspb.Message.getFieldWithDefault(msg, 11, ""),
clientgroupid: jspb.Message.getFieldWithDefault(msg, 12, ""),
clientemailaddress: jspb.Message.getFieldWithDefault(msg, 13, ""),
intakedate: jspb.Message.getFieldWithDefault(msg, 14, 0),
referralaccepteddate: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
legalmattercounty: jspb.Message.getFieldWithDefault(msg, 16, ""),
areaoflaw: jspb.Message.getFieldWithDefault(msg, 17, ""),
legalmatterstate: (f = msg.getLegalmatterstate()) && messages_core_message_pb.State.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.ClaimsLampCase}
 */
proto.cases_messages.ClaimsLampCase.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.ClaimsLampCase;
  return proto.cases_messages.ClaimsLampCase.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.ClaimsLampCase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.ClaimsLampCase}
 */
proto.cases_messages.ClaimsLampCase.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLampcaseid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvidername(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvideremail(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvidercity(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderstate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setProviderzip(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientnamefirst(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientnamelast(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientgroupid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientemailaddress(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIntakedate(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReferralaccepteddate(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalmattercounty(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setAreaoflaw(value);
      break;
    case 18:
      var value = new messages_core_message_pb.State;
      reader.readMessage(value,messages_core_message_pb.State.deserializeBinaryFromReader);
      msg.setLegalmatterstate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.ClaimsLampCase.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.ClaimsLampCase.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.ClaimsLampCase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.ClaimsLampCase.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMemberid();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAttyid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getProvidername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProvideremail();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProvidercity();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getProviderstate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getProviderzip();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getClientnamefirst();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getClientnamelast();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getClientgroupid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getClientemailaddress();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getIntakedate();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getLegalmattercounty();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAreaoflaw();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getLegalmatterstate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      messages_core_message_pb.State.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 caseID = 1;
 * @return {number}
 */
proto.cases_messages.ClaimsLampCase.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lampCaseId = 2;
 * @return {number}
 */
proto.cases_messages.ClaimsLampCase.prototype.getLampcaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setLampcaseid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.clearLampcaseid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.ClaimsLampCase.prototype.hasLampcaseid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 memberId = 3;
 * @return {number}
 */
proto.cases_messages.ClaimsLampCase.prototype.getMemberid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setMemberid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 attyId = 4;
 * @return {number}
 */
proto.cases_messages.ClaimsLampCase.prototype.getAttyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setAttyid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string providerName = 5;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getProvidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setProvidername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string providerEmail = 6;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getProvideremail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setProvideremail = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string providerCity = 7;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getProvidercity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setProvidercity = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string providerState = 8;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getProviderstate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setProviderstate = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string providerZip = 9;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getProviderzip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setProviderzip = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string clientNameFirst = 10;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getClientnamefirst = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setClientnamefirst = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string clientNameLast = 11;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getClientnamelast = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setClientnamelast = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string clientGroupID = 12;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getClientgroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setClientgroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string clientEmailAddress = 13;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getClientemailaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setClientemailaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 intakeDate = 14;
 * @return {number}
 */
proto.cases_messages.ClaimsLampCase.prototype.getIntakedate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setIntakedate = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 referralAcceptedDate = 15;
 * @return {number}
 */
proto.cases_messages.ClaimsLampCase.prototype.getReferralaccepteddate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setReferralaccepteddate = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.clearReferralaccepteddate = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.ClaimsLampCase.prototype.hasReferralaccepteddate = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string legalMatterCounty = 16;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getLegalmattercounty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setLegalmattercounty = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string areaOfLaw = 17;
 * @return {string}
 */
proto.cases_messages.ClaimsLampCase.prototype.getAreaoflaw = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.setAreaoflaw = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional core_messages.State legalMatterState = 18;
 * @return {?proto.core_messages.State}
 */
proto.cases_messages.ClaimsLampCase.prototype.getLegalmatterstate = function() {
  return /** @type{?proto.core_messages.State} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.State, 18));
};


/**
 * @param {?proto.core_messages.State|undefined} value
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
*/
proto.cases_messages.ClaimsLampCase.prototype.setLegalmatterstate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cases_messages.ClaimsLampCase} returns this
 */
proto.cases_messages.ClaimsLampCase.prototype.clearLegalmatterstate = function() {
  return this.setLegalmatterstate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.ClaimsLampCase.prototype.hasLegalmatterstate = function() {
  return jspb.Message.getField(this, 18) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.CaseListing.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.CaseListing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.CaseListing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CaseListing.toObject = function(includeInstance, msg) {
  var f, obj = {
caseid: jspb.Message.getFieldWithDefault(msg, 1, 0),
lampcaseid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
memberid: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
attyid: jspb.Message.getFieldWithDefault(msg, 4, 0),
providername: jspb.Message.getFieldWithDefault(msg, 5, ""),
clientname: jspb.Message.getFieldWithDefault(msg, 6, ""),
clientstate: jspb.Message.getFieldWithDefault(msg, 7, ""),
clientgroupid: jspb.Message.getFieldWithDefault(msg, 8, ""),
intakedate: jspb.Message.getFieldWithDefault(msg, 9, 0),
referralaccepteddate: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.CaseListing}
 */
proto.cases_messages.CaseListing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.CaseListing;
  return proto.cases_messages.CaseListing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.CaseListing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.CaseListing}
 */
proto.cases_messages.CaseListing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLampcaseid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMemberid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProvidername(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientname(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientstate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientgroupid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIntakedate(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setReferralaccepteddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.CaseListing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.CaseListing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.CaseListing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CaseListing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseid();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAttyid();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getProvidername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getClientname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getClientstate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getClientgroupid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIntakedate();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeInt64(
      10,
      f
    );
  }
};


/**
 * optional int32 caseID = 1;
 * @return {number}
 */
proto.cases_messages.CaseListing.prototype.getCaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setCaseid = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 lampCaseId = 2;
 * @return {number}
 */
proto.cases_messages.CaseListing.prototype.getLampcaseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setLampcaseid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.clearLampcaseid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CaseListing.prototype.hasLampcaseid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 memberId = 3;
 * @return {number}
 */
proto.cases_messages.CaseListing.prototype.getMemberid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setMemberid = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.clearMemberid = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CaseListing.prototype.hasMemberid = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 attyId = 4;
 * @return {number}
 */
proto.cases_messages.CaseListing.prototype.getAttyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setAttyid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string providerName = 5;
 * @return {string}
 */
proto.cases_messages.CaseListing.prototype.getProvidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setProvidername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string clientName = 6;
 * @return {string}
 */
proto.cases_messages.CaseListing.prototype.getClientname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setClientname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string clientState = 7;
 * @return {string}
 */
proto.cases_messages.CaseListing.prototype.getClientstate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setClientstate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string clientGroupID = 8;
 * @return {string}
 */
proto.cases_messages.CaseListing.prototype.getClientgroupid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setClientgroupid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 intakeDate = 9;
 * @return {number}
 */
proto.cases_messages.CaseListing.prototype.getIntakedate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setIntakedate = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 referralAcceptedDate = 10;
 * @return {number}
 */
proto.cases_messages.CaseListing.prototype.getReferralaccepteddate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.setReferralaccepteddate = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.CaseListing} returns this
 */
proto.cases_messages.CaseListing.prototype.clearReferralaccepteddate = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CaseListing.prototype.hasReferralaccepteddate = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.CaseSearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.CaseSearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.CaseSearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CaseSearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
term: jspb.Message.getFieldWithDefault(msg, 1, ""),
attyid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.CaseSearchRequest}
 */
proto.cases_messages.CaseSearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.CaseSearchRequest;
  return proto.cases_messages.CaseSearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.CaseSearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.CaseSearchRequest}
 */
proto.cases_messages.CaseSearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTerm(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.CaseSearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.CaseSearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.CaseSearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CaseSearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTerm();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string term = 1;
 * @return {string}
 */
proto.cases_messages.CaseSearchRequest.prototype.getTerm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.CaseSearchRequest} returns this
 */
proto.cases_messages.CaseSearchRequest.prototype.setTerm = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 attyId = 2;
 * @return {number}
 */
proto.cases_messages.CaseSearchRequest.prototype.getAttyid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CaseSearchRequest} returns this
 */
proto.cases_messages.CaseSearchRequest.prototype.setAttyid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.CaseSearchRequest} returns this
 */
proto.cases_messages.CaseSearchRequest.prototype.clearAttyid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CaseSearchRequest.prototype.hasAttyid = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cases_messages.CaseSearchResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.CaseSearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.CaseSearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.CaseSearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CaseSearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
casesList: jspb.Message.toObjectList(msg.getCasesList(),
    proto.cases_messages.Case.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.CaseSearchResponse}
 */
proto.cases_messages.CaseSearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.CaseSearchResponse;
  return proto.cases_messages.CaseSearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.CaseSearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.CaseSearchResponse}
 */
proto.cases_messages.CaseSearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cases_messages.Case;
      reader.readMessage(value,proto.cases_messages.Case.deserializeBinaryFromReader);
      msg.addCases(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.CaseSearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.CaseSearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.CaseSearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CaseSearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCasesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.cases_messages.Case.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Case cases = 1;
 * @return {!Array<!proto.cases_messages.Case>}
 */
proto.cases_messages.CaseSearchResponse.prototype.getCasesList = function() {
  return /** @type{!Array<!proto.cases_messages.Case>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cases_messages.Case, 1));
};


/**
 * @param {!Array<!proto.cases_messages.Case>} value
 * @return {!proto.cases_messages.CaseSearchResponse} returns this
*/
proto.cases_messages.CaseSearchResponse.prototype.setCasesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.cases_messages.Case=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cases_messages.Case}
 */
proto.cases_messages.CaseSearchResponse.prototype.addCases = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.cases_messages.Case, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cases_messages.CaseSearchResponse} returns this
 */
proto.cases_messages.CaseSearchResponse.prototype.clearCasesList = function() {
  return this.setCasesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.GetCaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.GetCaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.GetCaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetCaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
caseId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.GetCaseRequest}
 */
proto.cases_messages.GetCaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.GetCaseRequest;
  return proto.cases_messages.GetCaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.GetCaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.GetCaseRequest}
 */
proto.cases_messages.GetCaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.GetCaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.GetCaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.GetCaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetCaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 case_id = 1;
 * @return {number}
 */
proto.cases_messages.GetCaseRequest.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.GetCaseRequest} returns this
 */
proto.cases_messages.GetCaseRequest.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.GetCaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.GetCaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.GetCaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetCaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pb_case: (f = msg.getCase()) && proto.cases_messages.Case.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.GetCaseResponse}
 */
proto.cases_messages.GetCaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.GetCaseResponse;
  return proto.cases_messages.GetCaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.GetCaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.GetCaseResponse}
 */
proto.cases_messages.GetCaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cases_messages.Case;
      reader.readMessage(value,proto.cases_messages.Case.deserializeBinaryFromReader);
      msg.setCase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.GetCaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.GetCaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.GetCaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetCaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cases_messages.Case.serializeBinaryToWriter
    );
  }
};


/**
 * optional Case case = 1;
 * @return {?proto.cases_messages.Case}
 */
proto.cases_messages.GetCaseResponse.prototype.getCase = function() {
  return /** @type{?proto.cases_messages.Case} */ (
    jspb.Message.getWrapperField(this, proto.cases_messages.Case, 1));
};


/**
 * @param {?proto.cases_messages.Case|undefined} value
 * @return {!proto.cases_messages.GetCaseResponse} returns this
*/
proto.cases_messages.GetCaseResponse.prototype.setCase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cases_messages.GetCaseResponse} returns this
 */
proto.cases_messages.GetCaseResponse.prototype.clearCase = function() {
  return this.setCase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.GetCaseResponse.prototype.hasCase = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.GetLampCaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.GetLampCaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.GetLampCaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetLampCaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
caseId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.GetLampCaseRequest}
 */
proto.cases_messages.GetLampCaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.GetLampCaseRequest;
  return proto.cases_messages.GetLampCaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.GetLampCaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.GetLampCaseRequest}
 */
proto.cases_messages.GetLampCaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.GetLampCaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.GetLampCaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.GetLampCaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetLampCaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 case_id = 1;
 * @return {number}
 */
proto.cases_messages.GetLampCaseRequest.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.GetLampCaseRequest} returns this
 */
proto.cases_messages.GetLampCaseRequest.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.GetLampCaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.GetLampCaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.GetLampCaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetLampCaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
lampCase: (f = msg.getLampCase()) && proto.cases_messages.LampCase.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.GetLampCaseResponse}
 */
proto.cases_messages.GetLampCaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.GetLampCaseResponse;
  return proto.cases_messages.GetLampCaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.GetLampCaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.GetLampCaseResponse}
 */
proto.cases_messages.GetLampCaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cases_messages.LampCase;
      reader.readMessage(value,proto.cases_messages.LampCase.deserializeBinaryFromReader);
      msg.setLampCase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.GetLampCaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.GetLampCaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.GetLampCaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetLampCaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLampCase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cases_messages.LampCase.serializeBinaryToWriter
    );
  }
};


/**
 * optional LampCase lamp_case = 1;
 * @return {?proto.cases_messages.LampCase}
 */
proto.cases_messages.GetLampCaseResponse.prototype.getLampCase = function() {
  return /** @type{?proto.cases_messages.LampCase} */ (
    jspb.Message.getWrapperField(this, proto.cases_messages.LampCase, 1));
};


/**
 * @param {?proto.cases_messages.LampCase|undefined} value
 * @return {!proto.cases_messages.GetLampCaseResponse} returns this
*/
proto.cases_messages.GetLampCaseResponse.prototype.setLampCase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cases_messages.GetLampCaseResponse} returns this
 */
proto.cases_messages.GetLampCaseResponse.prototype.clearLampCase = function() {
  return this.setLampCase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.GetLampCaseResponse.prototype.hasLampCase = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.GetClaimsLampCaseRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.GetClaimsLampCaseRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.GetClaimsLampCaseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetClaimsLampCaseRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
caseId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.GetClaimsLampCaseRequest}
 */
proto.cases_messages.GetClaimsLampCaseRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.GetClaimsLampCaseRequest;
  return proto.cases_messages.GetClaimsLampCaseRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.GetClaimsLampCaseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.GetClaimsLampCaseRequest}
 */
proto.cases_messages.GetClaimsLampCaseRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCaseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.GetClaimsLampCaseRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.GetClaimsLampCaseRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.GetClaimsLampCaseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetClaimsLampCaseRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 case_id = 1;
 * @return {number}
 */
proto.cases_messages.GetClaimsLampCaseRequest.prototype.getCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.GetClaimsLampCaseRequest} returns this
 */
proto.cases_messages.GetClaimsLampCaseRequest.prototype.setCaseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.GetClaimsLampCaseResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.GetClaimsLampCaseResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.GetClaimsLampCaseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetClaimsLampCaseResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
pb_case: (f = msg.getCase()) && proto.cases_messages.ClaimsLampCase.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.GetClaimsLampCaseResponse}
 */
proto.cases_messages.GetClaimsLampCaseResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.GetClaimsLampCaseResponse;
  return proto.cases_messages.GetClaimsLampCaseResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.GetClaimsLampCaseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.GetClaimsLampCaseResponse}
 */
proto.cases_messages.GetClaimsLampCaseResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cases_messages.ClaimsLampCase;
      reader.readMessage(value,proto.cases_messages.ClaimsLampCase.deserializeBinaryFromReader);
      msg.setCase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.GetClaimsLampCaseResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.GetClaimsLampCaseResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.GetClaimsLampCaseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.GetClaimsLampCaseResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cases_messages.ClaimsLampCase.serializeBinaryToWriter
    );
  }
};


/**
 * optional ClaimsLampCase case = 1;
 * @return {?proto.cases_messages.ClaimsLampCase}
 */
proto.cases_messages.GetClaimsLampCaseResponse.prototype.getCase = function() {
  return /** @type{?proto.cases_messages.ClaimsLampCase} */ (
    jspb.Message.getWrapperField(this, proto.cases_messages.ClaimsLampCase, 1));
};


/**
 * @param {?proto.cases_messages.ClaimsLampCase|undefined} value
 * @return {!proto.cases_messages.GetClaimsLampCaseResponse} returns this
*/
proto.cases_messages.GetClaimsLampCaseResponse.prototype.setCase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cases_messages.GetClaimsLampCaseResponse} returns this
 */
proto.cases_messages.GetClaimsLampCaseResponse.prototype.clearCase = function() {
  return this.setCase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.GetClaimsLampCaseResponse.prototype.hasCase = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.CasesListRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.CasesListRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.CasesListRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CasesListRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
page: jspb.Message.getFieldWithDefault(msg, 1, 0),
limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
sortField: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
sortDir: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
searchField: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
searchString: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
attyId: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.CasesListRequest}
 */
proto.cases_messages.CasesListRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.CasesListRequest;
  return proto.cases_messages.CasesListRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.CasesListRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.CasesListRequest}
 */
proto.cases_messages.CasesListRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortField(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortDir(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchField(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchString(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.CasesListRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.CasesListRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.CasesListRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CasesListRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional int32 page = 1;
 * @return {number}
 */
proto.cases_messages.CasesListRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 limit = 2;
 * @return {number}
 */
proto.cases_messages.CasesListRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string sort_field = 3;
 * @return {string}
 */
proto.cases_messages.CasesListRequest.prototype.getSortField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.setSortField = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.clearSortField = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CasesListRequest.prototype.hasSortField = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string sort_dir = 4;
 * @return {string}
 */
proto.cases_messages.CasesListRequest.prototype.getSortDir = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.setSortDir = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.clearSortDir = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CasesListRequest.prototype.hasSortDir = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string search_field = 5;
 * @return {string}
 */
proto.cases_messages.CasesListRequest.prototype.getSearchField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.setSearchField = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.clearSearchField = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CasesListRequest.prototype.hasSearchField = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string search_string = 6;
 * @return {string}
 */
proto.cases_messages.CasesListRequest.prototype.getSearchString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.setSearchString = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.clearSearchString = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CasesListRequest.prototype.hasSearchString = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 atty_id = 7;
 * @return {number}
 */
proto.cases_messages.CasesListRequest.prototype.getAttyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.cases_messages.CasesListRequest} returns this
 */
proto.cases_messages.CasesListRequest.prototype.clearAttyId = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CasesListRequest.prototype.hasAttyId = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cases_messages.CasesListResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.CasesListResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.CasesListResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.CasesListResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CasesListResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
casesList: jspb.Message.toObjectList(msg.getCasesList(),
    proto.cases_messages.CaseListing.toObject, includeInstance),
paginationResponse: (f = msg.getPaginationResponse()) && messages_core_message_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.CasesListResponse}
 */
proto.cases_messages.CasesListResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.CasesListResponse;
  return proto.cases_messages.CasesListResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.CasesListResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.CasesListResponse}
 */
proto.cases_messages.CasesListResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cases_messages.CaseListing;
      reader.readMessage(value,proto.cases_messages.CaseListing.deserializeBinaryFromReader);
      msg.addCases(value);
      break;
    case 2:
      var value = new messages_core_message_pb.PaginationResponse;
      reader.readMessage(value,messages_core_message_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.CasesListResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.CasesListResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.CasesListResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.CasesListResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCasesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.cases_messages.CaseListing.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      messages_core_message_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CaseListing cases = 1;
 * @return {!Array<!proto.cases_messages.CaseListing>}
 */
proto.cases_messages.CasesListResponse.prototype.getCasesList = function() {
  return /** @type{!Array<!proto.cases_messages.CaseListing>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cases_messages.CaseListing, 1));
};


/**
 * @param {!Array<!proto.cases_messages.CaseListing>} value
 * @return {!proto.cases_messages.CasesListResponse} returns this
*/
proto.cases_messages.CasesListResponse.prototype.setCasesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.cases_messages.CaseListing=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cases_messages.CaseListing}
 */
proto.cases_messages.CasesListResponse.prototype.addCases = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.cases_messages.CaseListing, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cases_messages.CasesListResponse} returns this
 */
proto.cases_messages.CasesListResponse.prototype.clearCasesList = function() {
  return this.setCasesList([]);
};


/**
 * optional core_messages.PaginationResponse pagination_response = 2;
 * @return {?proto.core_messages.PaginationResponse}
 */
proto.cases_messages.CasesListResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.core_messages.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, messages_core_message_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.core_messages.PaginationResponse|undefined} value
 * @return {!proto.cases_messages.CasesListResponse} returns this
*/
proto.cases_messages.CasesListResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cases_messages.CasesListResponse} returns this
 */
proto.cases_messages.CasesListResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cases_messages.CasesListResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.SyncPassWithLampCaseIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.SyncPassWithLampCaseIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
lampCaseId: jspb.Message.getFieldWithDefault(msg, 1, 0),
attyId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.SyncPassWithLampCaseIdRequest}
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.SyncPassWithLampCaseIdRequest;
  return proto.cases_messages.SyncPassWithLampCaseIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.SyncPassWithLampCaseIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.SyncPassWithLampCaseIdRequest}
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLampCaseId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.SyncPassWithLampCaseIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.SyncPassWithLampCaseIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLampCaseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAttyId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 lamp_case_id = 1;
 * @return {number}
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.prototype.getLampCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.SyncPassWithLampCaseIdRequest} returns this
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.prototype.setLampCaseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 atty_id = 2;
 * @return {number}
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.prototype.getAttyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.SyncPassWithLampCaseIdRequest} returns this
 */
proto.cases_messages.SyncPassWithLampCaseIdRequest.prototype.setAttyId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cases_messages.SyncPassWithLampCaseIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.cases_messages.SyncPassWithLampCaseIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cases_messages.SyncPassWithLampCaseIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.SyncPassWithLampCaseIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
passCaseId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cases_messages.SyncPassWithLampCaseIdResponse}
 */
proto.cases_messages.SyncPassWithLampCaseIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cases_messages.SyncPassWithLampCaseIdResponse;
  return proto.cases_messages.SyncPassWithLampCaseIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cases_messages.SyncPassWithLampCaseIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cases_messages.SyncPassWithLampCaseIdResponse}
 */
proto.cases_messages.SyncPassWithLampCaseIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPassCaseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cases_messages.SyncPassWithLampCaseIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cases_messages.SyncPassWithLampCaseIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cases_messages.SyncPassWithLampCaseIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cases_messages.SyncPassWithLampCaseIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPassCaseId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 pass_case_id = 1;
 * @return {number}
 */
proto.cases_messages.SyncPassWithLampCaseIdResponse.prototype.getPassCaseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cases_messages.SyncPassWithLampCaseIdResponse} returns this
 */
proto.cases_messages.SyncPassWithLampCaseIdResponse.prototype.setPassCaseId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


goog.object.extend(exports, proto.cases_messages);
